import { gql } from "@apollo/client";

const GET_UNREAD_NOTIFICATIONS = gql`
  query GetNavbaInfo {
    me {
      unreadNotificationsCount
    }
  }
`;

export default GET_UNREAD_NOTIFICATIONS;
